import React from 'react'

import CustomFormModal from 'js/components/Form/CustomFields/CustomFormModal'

const AttendFormModal = ({
    form,
    isVisible,
    onClose,
    onSubmit,
    loading,
    formState,
    ...rest
}) => {
    if (!form) return null

    return (
        <CustomFormModal
            formFields={form.formFields}
            description={form.description}
            title={form.title}
            isVisible={isVisible}
            onClose={onClose}
            onSubmit={onSubmit}
            loading={loading}
            formState={formState}
            size="normal"
            showCloseButton
            {...rest}
        />
    )
}

export default AttendFormModal
